/* eslint-disable
    no-unused-vars,
*/
// TODO: This file was created by bulk-decaffeinate.
// Fix any style issues and re-enable lint.


import classnames from 'classnames'
import moment from 'moment'
import momentRange from 'moment-range'
import PropTypes from 'prop-types'
import DateTimePicker from 'react-daterange-picker'

import 'styles/components/TimeSelectorDropdown'

const TimeSelectorDropdown = React.createClass({
  propTypes: {
    onSetRange: PropTypes.func.isRequired,
    selectedDateRange: PropTypes.object
  },

  dateRangeLastNDays(days) {
    const start = moment().subtract(days, 'days').startOf('day')
    const end = moment().endOf('day')
    return moment.range(start, end)
  },

  clickWeek() {
    return this.props.onSetRange(this.dateRangeLastNDays(6))
  },

  clickMonth() {
    return this.props.onSetRange(this.dateRangeLastNDays(29))
  },

  handleRangeChange(range) {
    const selectedRange = moment.range(range.start.startOf('day'), range.end.endOf('day'))
    return this.props.onSetRange(selectedRange)
  },

  createDropdown() {
    return [
      <div>
        <div className="preset-time-buttons">
          <button className="dsg-MediumButton" onClick={this.clickWeek}>
            last week
          </button>
          <button className="dsg-MediumButton" onClick={this.clickMonth}>
            last month
          </button>
        </div>
      </div>,
      <DateTimePicker
        selectionType="range"
        value={this.props.selectedDateRange}
        onSelect={this.handleRangeChange} />
    ]
  },

  render() {
    return (
      <div className="TimeSelectorDropdown" onClick={this.handleOnClick}>
        {this.createDropdown()}
      </div>
    )
  }
})

export default TimeSelectorDropdown



// WEBPACK FOOTER //
// ./src/scripts/components/shared/TimeSelectorDropdown.js